import HomeRoundedIcon from '@mui/icons-material/HomeRounded'
import { Breadcrumbs as MuiBreadcrumbs } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

type BreadcrumbsProps = {
  children: React.ReactNode
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ children }) => {
  const navigate = useNavigate()

  const handleNavigate = (path?: string): void => {
    if (path && path !== '') navigate(path)
  }

  return (
    <MuiBreadcrumbs aria-label='breadcrumb' color='text.primary' separator='>'>
      <HomeRoundedIcon
        color='primary'
        sx={{ mb: 0.3, display: 'flex', alignItems: 'start', cursor: 'pointer', fontSize: 24 }}
        onClick={() => handleNavigate('/')}
      />
      {children}
    </MuiBreadcrumbs>
  )
}

export default Breadcrumbs
